
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Line } from '@vds/lines';
import { nativeSetTitle } from "../../../shared/utilities/native";
const Link = styled.a`
  color: ${(props) => (props.count >= 1 && '#959595')};
  &:hover {
    color: ${(props) => (props.count >= 1 && '#959595')};
  }`;

const StepWiseProgress = styled.div`
width:100%;
font-size: 16px;
`;
const Linecomp = styled(Line)`
height: 0.2rem !important;
background-color: red;
`;
const FloatRightDiv = styled.div`
width: 88%;
display:inline-flex
`
//changed the desktopview width to 90% because of CXTDT-432945
const DesktopView = styled.div`
width: 100%;

// margin-left: -8%;
position: relative;
`;

const MobileViewDiv = styled.div`
position: relative;
width: 100%;
font-size: 0px;
& p{
  font-size:16px;
}
& span {
  margin-left:-21px;
}
`;


class ProgressBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clickCount: 0,
    };
  }
  componentDidMount() {
    try {
      if (typeof (_isNative) !== "undefined" && _isNative) {
        const stepsCompleted = parseInt(this.props?.stepsCompleted, 10);
        const Title = this.props?.tabs.filter((k, idx) => idx + 1 === stepsCompleted);
        if(window.location.hash !== "#/ildfeaturecompare"){
              nativeSetTitle(Title && Title.length > 0 ? Title[0] : "International Plan");
        }
      }
    }catch(ex){}
  }
  backCtaApi(stepCompleted, path, flowName) {
    this.setState({ clickCount: this.state.clickCount + 1 });

    if (stepCompleted === 2) {
      if (flowName === 'ildfeaturecompare') {
        this.props.history.push('ildeffectivedate');
      }
      else if (flowName === 'ildeffectivedate') {
        this.props.history.push('ilddeviceselection');
      }
      else if(flowName === 'ilddeviceselection'){
        this.props.history.push('ilddestination');
      }
      else {
        // this.props.history.push('itpdestination');
        this.props.history.goBack();
      }
    }
    else if (stepCompleted === 3) {
      if (flowName === 'ildreviewpage') {
        this.props.history.push('ildfeaturecompare');
      }
      else {
        this.props.history.goBack();
        //this.props.history.push('itptraveldates');
      }
    }
    else if (stepCompleted === 4) {
      if (flowName === 'ildremarks') {
        this.props.history.push('ildreviewpage');
      }
      else {
        this.props.history.goBack();
      }
    }
    
    else{
      this.props.history.goBack();
    }
  }

  tabNames(stepsCompleted, item, index, viewType,disableReviewProgessBar) {
    if (item.stepCompleted && (viewType !== 'mobileView')) {
      return (
        <StepWiseProgress
          aria-current={stepsCompleted-1 === index ? 'true' : ''}
          aria-label={stepsCompleted-1 === index ? `${item.stepName} InProgress` : index != disableReviewProgessBar ? `${item.stepName} Completed` : `${item.stepName}`}
          className={index+1 != disableReviewProgessBar && 'bold'}>
          {/* <span>{item.stepName}</span> */}
          <span style={{opacity: index+1 == disableReviewProgessBar ?'.5':'none'}}>{item.stepName}</span>
          {index+1 != disableReviewProgessBar &&
          <Linecomp
            type="accent"
            inverted={false}
          />
          }
        </StepWiseProgress>
      );
    } else if (viewType === 'mobileView') {
      if (item.stepCompleted) {
        return (
          <StepWiseProgress
            aria-current={stepsCompleted === index + 1 ? `${item.stepName} InProgress` : `${item.stepName} Completed`}
            aria-label={`${item.stepName}`}
            className={stepsCompleted === index + 1 && 'bold'}>
            <Line
              type="accent"
              inverted={false}
            />
          </StepWiseProgress>
        )
      }
      return (
        <StepWiseProgress
          aria-current={`${item.stepName} Not started`} 
          aria-label={`${item.stepName}`}
          >
          <Line
            type="xLight"
            inverted={false}
          />
        </StepWiseProgress>
      )
    }
    return (
      <StepWiseProgress
        // aria-current={`${item.stepName} Not started`}
        aria-label={`${item.stepName}`}
        className={stepsCompleted === index + 1 && 'bold'} >
        <span>{item.stepName}</span>
         {item.stepCompleted ?
          <Line
            type="accent"
            inverted={false}
          /> : <Line
            type="xLight"
            inverted={false}
          />}
      </StepWiseProgress>
    );
  }

  render() {
    const { tabs } = this.props;
    const width = (100 / (tabs.length)) + '%';
    const stepsCompleted = parseInt(this.props.stepsCompleted, 10);
    const flowName = (this.props && this.props.flowName) ? this.props.flowName : "";
    const tabsArray = [];
    const path = this.props.path || null;
    tabs.map((item, index) => { // eslint-disable-line
      if (index < stepsCompleted) {
        tabsArray.push({ stepName: item, stepCompleted: true });
      } else {
        tabsArray.push({ stepName: item, stepCompleted: false });
      }
    });
    const BackButtonStyle = styled.div`
    display: inline-flex;
    margin-right: 20px;
    font-size: 1rem;
    `;
    let disableStyles = (this.state.clickCount >= 1) || this.props.disableBackButton ? 'secondaryCTA disableBackButton disabledArrow color_959595' : 'secondaryCTA color_000';
    return (
      <div data-testid="progressBar">
        <DesktopView className="desktopView clearfix pad20">
          <BackButtonStyle className="floatLeft progress_bar_backButton" >
            {stepsCompleted > 1 && !this.props.disableBackButton &&
              <Link role="link" href="javascript:void(0);" aria-label="Back" className={`${disableStyles} m-back bold displayBlock`} onKeyDown={(e) => { if (e.keyCode === 13 || e.keyCode === 32) { this.backCtaApi(stepsCompleted, path, flowName); } }} onClick={() => { this.backCtaApi(stepsCompleted, path, flowName) }}>Back</Link>
            }
          </BackButtonStyle>
          <FloatRightDiv
            className="floatRight"
            role="progressbar"
            aria-label={`Step ${stepsCompleted} of ${tabs.length}${tabsArray[stepsCompleted - 1] ? `, ${tabsArray[stepsCompleted - 1].stepName}` : ''}`}
            aria-valuemin={1}
            aria-valuemax={tabs.length}
            aria-valuenow={stepsCompleted}
          >
            {tabsArray.map((item, index) => (
              <div className={index !== 0 ? 'pad3 onlyLeftPad' : ''} key={'stepName' + index} style={{ width, display: 'inline-block' }}>
                {this.tabNames(stepsCompleted, item, index,'',this.props.disableReviewProgessBar)}
              </div>
            ))}
          </FloatRightDiv>
        </DesktopView>
        { !(typeof (_isNative) !== "undefined" && _isNative) &&
          <MobileViewDiv className="mobileView">
            {tabs.map((item, idx) => (idx + 1 === stepsCompleted) && <p key={'stepName' + idx} className="textAlignCenter bold  pad12 noSidePad border_grayThree onlyBottomBorder">
              {stepsCompleted > 1 &&
                <Link aria-label="Back" className={`${disableStyles} m-back bold fontSize_5 displayBlock`} style={{ fontSize: '1rem' }} role="link" onClick={() => { this.backCtaApi(stepsCompleted, path, flowName); }} />
              }
              <span>{item}</span>
            </p>)}
            {tabsArray.map((item, index) => (
              <div className={index !== 0 ? 'pad1 onlyLeftPad' : ''} key={'step' + index} style={{ width, display: 'inline-block', paddingLeft: '1px' }}>
                {this.tabNames(stepsCompleted, item, index, 'mobileView',this.props.disableReviewProgessBar)}
              </div>
            ))}
          </MobileViewDiv>
        }
      </div >
    );
  }
}

ProgressBar.propTypes = {
  tabs: PropTypes.array,
  stepsCompleted: PropTypes.string,
  backCtaUrl: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgressBar));